import axios from 'axios';
import { GatewayV2Types } from '../../services/gatewayV2/gatewayV2.types';

export class GatewayV2Provider {
    constructor(protected path: string) {}

    get prefix() {
        return `${this.path}/gw2`;
    }

    public preApprovalsSearch = async (data: Pick<GatewayV2Types.PreApprovalsSearchRequest, 'isFullProfile'>) => {
        try {
            await axios.post<void>(`${this.prefix}/pre-approvals-search/`, data, {
                withCredentials: true,
            });
        } catch (e) {
            return null;
        }
    };

    public getStatusesV2 = async () => {
        const { data } = await axios.get<GatewayV2Types.StatusesV2Response>(`${this.prefix}/statuses-v2/`, {
            withCredentials: true,
        });
        return data;
    };

    public sendApplicationV2 = async (request: GatewayV2Types.LoansApplicationV2ClientRequest) => {
        try {
            const { data } = await axios.post<GatewayV2Types.LoansApplicationV2Response>(
                `${this.prefix}/application/`,
                request,
                {
                    withCredentials: true,
                },
            );
            return data;
        } catch (e) {
            return null;
        }
    };
}
